import { map, Observable, Subject, takeUntil } from 'rxjs';
import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  HostBinding,
  OnDestroy,
  QueryList,
} from '@angular/core';
import { StretchedLinkDirective } from './../stretched-link/stretched-link.directive';

@Component({
    selector: 'lui-card-doc',
    templateUrl: './card-doc.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CardDocComponent implements AfterContentInit, OnDestroy {
  @HostBinding('class') hostClass = 'lui-card-doc';

  // @HostBinding('tabindex') tabindex = 0;

  @HostBinding('class.lui-card-doc-link') linkClass = false;

  @ContentChildren(StretchedLinkDirective, { descendants: true })
  stretchedLinks!: QueryList<StretchedLinkDirective>;

  _destroy = new Subject<void>();

  ngAfterContentInit(): void {
    this._setLinkClass(this.stretchedLinks);

    const stretchedLinkStream: Observable<QueryList<StretchedLinkDirective>> =
      this.stretchedLinks.changes;

    stretchedLinkStream
      .pipe(takeUntil(this._destroy))
      .subscribe((queryList) => {
        this._setLinkClass(queryList);
      });
  }

  ngOnDestroy(): void {
    this._destroy.next();
    this._destroy.complete();
  }

  private _setLinkClass(queryList: QueryList<StretchedLinkDirective>): void {
    this.linkClass = queryList.length > 0;
  }
}
